import { render, staticRenderFns } from "./ProductTagging.vue?vue&type=template&id=f5d0035e&scoped=true&"
import script from "./ProductTagging.vue?vue&type=script&lang=js&"
export * from "./ProductTagging.vue?vue&type=script&lang=js&"
import style0 from "./ProductTagging.vue?vue&type=style&index=0&id=f5d0035e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d0035e",
  null
  
)

export default component.exports